<!-- <div
(dblclick)="select($event)"
class="note-default"
style="position:absolute;"
[ngStyle]="{ 'top.%': y, 'left.%': x}"
[ngClass]="{'new': note.temporal_id}"
> -->
<!-- <div class="note-default" ngDraggable [ngResizable]="false" (endOffset)="onMoveEnd($event)"> -->
    <div
    (dblclick)="select($event)"
    [ngStyle]="{ 'top.%': y, 'left.%': x}"
    class="note-bullet"
    [ngClass]="{'new': note.id==0}"
    (click)="open($event)"
    [ngDraggable]="draggable"
    [ngResizable]="false"
    [handle]="MoveHandle"
    [bounds]="moveBounds"
    [inBounds]="draggable"
    [preventDefaultEvent]="draggable"
    (endOffset)="onMoveEnd($event)"
    (movingOffset)="onMoving($event)"
    >
        <span #MoveHandle>{{note.id!=0? index : '&nbsp;'}}</span>
    </div>
    <div
    (dblclick)="select($event)"
    [ngStyle]="{ 'top.%': y, 'left.%': x}"
    [hidden]="!opened"
    class="note-content"
    ngDraggable
    [bounds]="moveBounds"
    [position]="currentPosition"
    (endOffset)="onMoveContentEnd($event)"
    >
    <div class="arrow"></div>
      <div [hidden]="note.id!=0">
          <a (click)="remove($event)">x</a>
          <textarea class="resizer" #txtArea placeholder="Please, write here." [formControl]="formControl" required></textarea>
      </div>
      <p *ngIf="note.id">{{note.description}}</p>
      <p *ngIf="note.id"
        class="author"
      >By {{note.user.name}}</p>
    </div>
<!-- </div> -->
<!--</div> -->
